import { StoragePort } from 'shared/ports/storage_port';

class LocalStorageAdapter implements StoragePort {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return this.memory.get(key) ?? null;
    }
  }

  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      this.memory.set(key, value);
    }
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      this.memory.delete(key);
    }
  }

  clear(): void {
    try {
      localStorage.clear();
    } catch {
      this.memory.clear();
    }
  }

  getJSON<T>(key: string): T | null {
    const value = this.get(key);
    if (value == null) return null;
    try {
      return JSON.parse(value) as T;
    } catch {
      return null;
    }
  }

  setJSON<T>(key: string, value: T): void {
    this.set(key, JSON.stringify(value));
  }

  private memory = new Map<string, string>();
}

export const storageAdapter: StoragePort = new LocalStorageAdapter();


